"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypeGuards = exports.makeTypeGuard = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const common_1 = require("@finley-technologies/common");
const makeTypeGuard = (schema, onErrors) => (obj) => {
    const { valid, errors } = jsonschema_1.default.validate(obj, schema, {
        nestedErrors: true,
    });
    if (errors.length > 0 && onErrors) {
        onErrors(errors, obj);
    }
    return valid;
};
exports.makeTypeGuard = makeTypeGuard;
function createTypeGuards(configSchema, nodeSchema, artifactType) {
    const isNodeConfig = (0, exports.makeTypeGuard)(configSchema, (errors, instance) => {
        (0, common_1.debugLog)(`Error validating config schema for ${artifactType}`, errors, instance);
    });
    const typeGuardFn = (0, exports.makeTypeGuard)(nodeSchema, (errors, instance) => {
        (0, common_1.debugLog)(`Error validating schema for ${artifactType}`, errors, instance);
    });
    const typeGuard = (obj) => {
        // strip out the db timestamps before validating.
        return typeGuardFn(common_1.utils.stripDbTimeStamps(obj));
    };
    // isNode is a lightweight check to narrow down the type of the object
    // use it only when input is trusted DbTable.ArtifactWithSlugs.
    // for usage within tape-builder, use typeGuard instead.
    const isNode = (obj) => {
        return obj.type === artifactType;
    };
    return { isNodeConfig, typeGuard, isNode };
}
exports.createTypeGuards = createTypeGuards;
//# sourceMappingURL=typeguards.js.map